import React from 'react'
import { FormattedMessage, FormattedNumber } from 'react-intl'
import {
  Button,
  Grid,
  Fade,
  Accordion,
  AccordionSummary,
  Typography,
  AccordionDetails, InputLabel, Box
} from '@material-ui/core'
import { FormLoader } from '../../../Loader/FormLoader'
import { formStyles } from '../FormStyles'
import { useStyles } from './Styles'
import invoicesTypes from '../../../../configurations/invoices-types'
import invoicesSubTypes from '../../../../configurations/invoices-sub-types'
import receiverTypes from '../../../../configurations/receiver-types'
import ArrowForwardIosOutlinedIcon from '@material-ui/icons/ArrowForwardIosOutlined'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import TuneSharpIcon from '@material-ui/icons/TuneSharp'
import PostAddSharpIcon from '@material-ui/icons/PostAddSharp'
import ArrowUpwardOutlinedIcon from '@material-ui/icons/ArrowUpwardOutlined'
import ArrowDownwardOutlinedIcon from '@material-ui/icons/ArrowDownwardOutlined'
import ArrowBackIosOutlinedIcon from '@material-ui/icons/ArrowBackIosOutlined'
import CreditCardIcon from '@material-ui/icons/CreditCard'
import LocalShippingSharpIcon from '@material-ui/icons/LocalShippingSharp'
import 'moment/locale/ar-sa'
import Moment from 'react-moment'
import ItemsList from '../Step3/ItemsList'
import { calculateDecimal, concatBranchAddress } from '../../../../utils/helpers'
import { CreateInvoiceConsumer } from '../../../../context/CreateInvoiceContext'
import AddNewDialog from '../../../Dialog/AddNewDialog'
import { ListingProvider, ListingConsumer } from '../../../../context/ListingContext'
import InvoiceSignCertificates from './InvoiceSignCertificates'
import SaveInvoiceBtn from '../../SaveInvoiceBtn'
import { ListingTableProvider , ListingTableConsumer} from '../../../../context/ListingTableContext'

const InvoiceCreateStep6 = ({ invoiceData, onSubmit, locale, invoiceSubmissionLoading, taxpayerData, signInvoice, handleSaveInvoiceEntity, savedTemplateData }) => {
  const formClasses = formStyles()
  const classes = useStyles()
  const [signDialogOpen, setSignDialogOpen] = React.useState(false)
  const handleSignDialog = (e) => {
    !!e?.preventDefault && e.preventDefault()
    !!e?.stopPropagation && e.stopPropagation()

    if (!signDialogOpen) {
      let url = 'etaxwebsignclient://launch'
      const link = document.createElement('a')
      link.href = url
      document.body.appendChild(link)
      link.click()
      link.remove()
      window.URL.revokeObjectURL(url)
    }
    setSignDialogOpen(!signDialogOpen)
  }

  const getColumnValue = (key, value) => {
    if (!!key) {
      switch (key) {
        case 'documentType':
          let type = invoicesTypes?.filter(item => item.key === value)
          return !!type.length ? type[0][`name_${locale}`] : value
        case 'documentSubType':
          let subType = invoicesSubTypes?.filter(item => item.key === value)
          return !!subType.length ? subType[0][`name_${locale}`] : value

        case 'receiverType':
          let receiverType = receiverTypes?.filter(item => item.key === value)
          return !!receiverType.length ? receiverType[0][`name_${locale}`] : value

        case 'issuerBranchID':
          let branch = taxpayerData?.branches?.filter(branch => branch.branchID === value)
          return !!branch?.length ? `${branch[0]?.name} (${value})` : value

        case 'taxpayerActivityCode':
          let activityBranch = taxpayerData?.branches?.filter(branch => branch.branchID === invoiceData?.step2?.issuerBranchID)
          let activity = !!activityBranch.length ? activityBranch[0]?.taxpayerActivities?.filter(act => act.activityTypeCode === value) : []
          return !!activity.length ? `${activity[0][`activityTypeName_${locale}`]} (${value})` : value

        case 'issuerAddress':
        case 'receiverAddress':
          return concatBranchAddress(value)

        case 'taxTotals':
          let sum = 0
          if (!!value?.length) {
            value?.forEach(tax => {
              sum += parseFloat(tax?.amount || 0)
            })
          }
          return <FormattedNumber value={calculateDecimal(sum)} minimumFractionDigits={2}/>

        case 'documentTypeVersion':
          return <FormattedMessage id={`documentTypeVersion.${value}`}/>

        case 'dateTimeIssued':
          return <Moment locale={locale === 'ar' ? 'ar-sa' : 'en-us'}
                         format="DD-MM-yyyy hh:mm A">{!!invoiceData?.step1.dateTimeIssuedEdit ? value : new Date()}</Moment>

        case 'dateValidity':
          return <Moment locale={locale === 'ar' ? 'ar-sa' : 'en-us'}
                         format="DD-MM-yyyy hh:mm A">{value}</Moment>

        case 'grossWeight':
        case 'netWeight':
          return <>{value} <FormattedMessage id='kg'/></>

        default:
          return value
      }
    } else {
      return ''
    }
  }

  const [sameCurrency, setSameCurrency] = React.useState(true)
  const [exactCurrency, setExactCurrency] = React.useState({
    id: 0,
    key: 'EGP',
    name_en: 'Egyptian Pound',
    name_ar: 'جنيه مصري',
    rate: 1
  })

  React.useEffect(() => {
      if (!!invoiceData.step3?.invoiceLines?.length) {
        let currency = invoiceData.step3?.invoiceLines.map(item => item.amountSold)
        let sameCurrencyFlag = new Set(currency).size === 1
        setSameCurrency(sameCurrencyFlag)
        let currencyObj = !!sameCurrencyFlag ? invoiceData.step3?.invoiceLines.map(item => item.currencyRate)?.filter(currencyItem => currencyItem.key === currency[0]) : []
        setExactCurrency(currencyObj?.length ? currencyObj[0] : {
          id: 0,
          key: 'EGP',
          name_en: 'Egyptian Pound',
          name_ar: 'جنيه مصري',
          rate: 1
        })
      }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [invoiceData.step3?.invoiceLines])

  return (
    <Fade in={true}>
      <Grid container spacing={3} direction={'row-reverse'}>
        {!!invoiceSubmissionLoading && <FormLoader loading={true}/>}
        <Grid item xs={12} sm={12} lg={4}>
          {!!Object.keys(invoiceData?.step1 || {}).length &&
          <Accordion defaultExpanded={true}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon/>}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <div className={formClasses.ItemHeadingWrapper}>
                <Typography className={formClasses.ItemHeading}><TuneSharpIcon/><FormattedMessage
                  id='Invoice.Create.Step1.Title'/></Typography>
              </div>
            </AccordionSummary>
            <AccordionDetails>
              <div className={formClasses.EntityInfoWrapper + ' noBottomGutter'}>
                {Object.keys(invoiceData?.step1 || {}).map((column, index) => (
                  !!invoiceData?.step1[column] && !!['documentType', 'documentTypeVersion', 'documentSubType', 'internalID', 'dateTimeIssued'].includes(column) &&
                  <div className={formClasses.FormItem + ' info'} key={index}>
                    <InputLabel><FormattedMessage id={`Fields.label.${column}`}/>:</InputLabel>
                    <div className={'info-data'}>
                      <strong>{getColumnValue(column, invoiceData?.step1[column])}</strong>
                    </div>
                  </div>
                ))}
              </div>
            </AccordionDetails>
          </Accordion>
          }
          {!!Object.keys(invoiceData?.step2 || {}).length &&
          <div className={classes.senderReceiverWrapper}>
            <div className={classes.senderReceiver}>
              <Accordion defaultExpanded={true}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon/>}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <div className={formClasses.ItemHeadingWrapper}>
                    <Typography className={formClasses.ItemHeading}><ArrowUpwardOutlinedIcon color={'primary'}/>
                      <FormattedMessage id='InvoiceSteps.step2.Issuer.title'/></Typography>
                  </div>
                </AccordionSummary>
                <AccordionDetails>
                  <div className={formClasses.EntityInfoWrapper + ' noBottomGutter'}>
                    {['issuerName', 'issuerID', 'issuerBranchID', 'taxpayerActivityCode', 'issuerAddress'].map((column, index) => (
                      !!invoiceData?.step2[column] &&
                      <div
                        className={formClasses.FormItem + ' info' + (column === 'issuerAddress' ? ' ' + formClasses.FormRow : '')}
                        key={index}>
                        <InputLabel><FormattedMessage id={`Fields.label.${column}`}/>:</InputLabel>
                        <div className={'info-data'}>
                          <strong>{getColumnValue(column, invoiceData?.step2[column])}</strong>
                        </div>
                      </div>
                    ))}
                  </div>
                </AccordionDetails>
              </Accordion>
            </div>
            <div className={classes.senderReceiver}>
              <Accordion defaultExpanded={true}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon/>}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <div className={formClasses.ItemHeadingWrapper}>
                    <Typography className={formClasses.ItemHeading}><ArrowDownwardOutlinedIcon color={'secondary'}/>
                      <FormattedMessage id='InvoiceSteps.step2.Receiver.title'/></Typography>
                  </div>
                </AccordionSummary>
                <AccordionDetails>
                  <div className={formClasses.EntityInfoWrapper + ' noBottomGutter'}>
                    {['receiverName', 'receiverID', 'receiverType', 'receiverAddress'].map((column, index) => (
                      !!invoiceData?.step2[column] &&
                      <div
                        className={formClasses.FormItem + ' info' + (column === 'receiverAddress' ? ' ' + formClasses.FormRow : '')}
                        key={index}>
                        <InputLabel><FormattedMessage
                          id={`Fields.label.${column}${column === 'receiverID' ? `.${invoiceData?.step2?.receiverType}` : ''}`}/>:</InputLabel>
                        <div className={'info-data'}>
                          <strong>{getColumnValue(column, invoiceData?.step2[column])}</strong>
                        </div>
                      </div>
                    ))}
                  </div>
                </AccordionDetails>
              </Accordion>
            </div>
          </div>
          }
        </Grid>
        <Grid item xs={12} sm={12} lg={8}>
          <Accordion defaultExpanded={true}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon/>}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <div className={formClasses.ItemHeadingWrapper}>
                <Typography className={formClasses.ItemHeading}><PostAddSharpIcon/><FormattedMessage
                  id='Invoice.Create.Step3.Title'/></Typography>
              </div>
            </AccordionSummary>
            <AccordionDetails>
              <div className={formClasses.EntityInfoWrapper}>
                {!!Object.keys(invoiceData?.step3 || {}).length &&
                <>
                  <ListingTableProvider listArr={invoiceData?.step3?.invoiceLines || []}>
                    <ListingTableConsumer>
                      {({
                          handleChangeListingPage, handleChangeListingRowsPerPage, listingCount,
                          listingData, listingPage, listingRowsPerPage
                        }) =>(
                        <ItemsList
                          handleChangeListingPage={handleChangeListingPage}
                          handleChangeListingRowsPerPage={handleChangeListingRowsPerPage}
                          listingCount={listingCount} listingData={listingData}
                          documentType={invoiceData?.step1?.documentType}
                          listingPage={listingPage} listingRowsPerPage={listingRowsPerPage}
                          locale={locale} sameCurrency={sameCurrency} currentCurrency={exactCurrency} noActions/>
                      )}
                    </ListingTableConsumer>
                  </ListingTableProvider>
                  <div className={formClasses.FormTotals + ' ' + classes.itemsCalculations}>
                    {['netAmount', 'totalItemsDiscountAmount', 'taxTotals', 'extraDiscountAmount', 'totalAmount'].map((column, index) => (
                      !!invoiceData?.step3[column] &&
                      <div
                        className={formClasses.FormItem + ' info ' + formClasses.FormRow + (column === 'totalAmount' ? ' total' : '')}
                        key={index}>
                        <InputLabel><FormattedMessage
                          id={`Fields.label.${column}`}/> ({exactCurrency?.key})</InputLabel>
                        <div className={'info-data'}>
                          <strong>{getColumnValue(column, column === 'taxTotals' ? invoiceData?.step3[column]: <FormattedNumber value={invoiceData?.step3[column]} minimumFractionDigits={2}/>)}</strong>
                        </div>
                      </div>
                    ))}
                  </div>
                </>
                }
              </div>
            </AccordionDetails>
          </Accordion>

          {((!!Object.keys(invoiceData?.step4 || {}).length && !!Object.keys(invoiceData?.step4 || {})?.filter(column => !!invoiceData?.step4[column])?.length) ||
            (!!Object.keys(invoiceData?.step5 || {}).length && !!Object.keys(invoiceData?.step5 || {})?.filter(column => !!invoiceData?.step5[column])?.length)) &&
          <div className={classes.paymentDeliveryWrapper}>
            {!!Object.keys(invoiceData?.step4 || {}).length && !!Object.keys(invoiceData?.step4 || {})?.filter(column => !!invoiceData?.step4[column])?.length &&
            <div className={classes.paymentDelivery}>
              <Accordion defaultExpanded={true}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon/>}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <div className={formClasses.ItemHeadingWrapper}>
                    <Typography className={formClasses.ItemHeading}><CreditCardIcon/>
                      <FormattedMessage id='Invoice.Create.Step4.Title'/></Typography>
                  </div>
                </AccordionSummary>
                <AccordionDetails>
                  <div className={formClasses.EntityInfoWrapper + ' noBottomGutter'}>
                    {Object.keys(invoiceData?.step4)?.map((column, index) => (
                      !!invoiceData?.step4[column] &&
                      <div
                        className={formClasses.FormItem + ' info' + (column === 'issuerAddress' ? ' ' + formClasses.FormRow : '')}
                        key={index}>
                        <InputLabel><FormattedMessage id={`Fields.label.${column}`}/>:</InputLabel>
                        <div className={'info-data'}>
                          <strong>{getColumnValue(column, invoiceData?.step4[column])}</strong>
                        </div>
                      </div>
                    ))}
                  </div>
                </AccordionDetails>
              </Accordion>
            </div>
            }
            {!!Object.keys(invoiceData?.step5 || {}).length && !!Object.keys(invoiceData?.step5)?.filter(column => !!invoiceData?.step5[column])?.length &&
            <div className={classes.paymentDelivery}>
              <Accordion defaultExpanded={true}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon/>}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <div className={formClasses.ItemHeadingWrapper}>
                    <Typography className={formClasses.ItemHeading}><LocalShippingSharpIcon/>
                      <FormattedMessage id='Invoice.Create.Step5.Title'/></Typography>
                  </div>
                </AccordionSummary>
                <AccordionDetails>
                  <div className={formClasses.EntityInfoWrapper + ' noBottomGutter'}>
                    {Object.keys(invoiceData?.step5)?.map((column, index) => (
                      !!invoiceData?.step5[column] &&
                      <div
                        className={formClasses.FormItem + ' info' + (column === 'issuerAddress' ? ' ' + formClasses.FormRow : '')}
                        key={index}>
                        <InputLabel><FormattedMessage id={`Fields.label.${column}`}/>:</InputLabel>
                        <div className={'info-data'}>
                          <strong>{getColumnValue(column, invoiceData?.step5[column])}</strong>
                        </div>
                      </div>
                    ))}
                  </div>
                </AccordionDetails>
              </Accordion>
            </div>
            }
          </div>
          }
        </Grid>

        {invoiceData?.step1?.documentTypeVersion?.toString() === '1.0' &&
        <AddNewDialog
          children={
            <ListingProvider entityName={'userCertificates'} reCallToGetData={12}>
              <ListingConsumer>
                {({ listingData, listingLoading, listingFinishRecall, refreshListingData }) => (
                  <InvoiceSignCertificates certificates={listingData} certificatesLoading={listingLoading}
                                           invoiceSubmissionLoading={invoiceSubmissionLoading}
                                           certificatesFinishRecall={listingFinishRecall}
                                           refreshListingData={refreshListingData}
                                           cancelDialog={handleSignDialog} onSubmit={signInvoice}
                                           formClasses={formClasses}

                  />
                )}
              </ListingConsumer>
            </ListingProvider>

          }
          DialogTitle={<FormattedMessage id={`Invoice.sign.Form.Title`}/>}
          isDialogOpen={signDialogOpen}
          cancelDialog={handleSignDialog}/>
        }

        <CreateInvoiceConsumer>
          {({ handleBackStep }) => (
            <Box px={3} mb={5} className={formClasses.FormSubmitRow + ' between'}>
              <Button variant={'outlined'} size={'large'} color={'secondary'}
                      className={formClasses.InvoiceStepGoBack} onClick={handleBackStep}>
                {locale === 'ar' ? <ArrowForwardIosOutlinedIcon/> : <ArrowBackIosOutlinedIcon/>}
                <FormattedMessage id='requestStep.button.previous'/>
              </Button>
              <div>
                <SaveInvoiceBtn savedTemplateData={savedTemplateData}
                                handleSaveInvoiceEntity={(e, entityType, tempData, formikActions, closeDialog) => handleSaveInvoiceEntity(e, entityType,
                                  null, null, tempData, formikActions, closeDialog)}/>
                <Button type={'submit'} variant={'contained'} size={'large'} color={'secondary'}
                        onClick={(e) => {
                          !!e?.preventDefault && e.preventDefault()
                          !!e?.stopPropagation && e.stopPropagation()
                          invoiceData?.step1?.documentTypeVersion?.toString() === '1.0' ? handleSignDialog() : onSubmit()

                        }}
                >
                  <FormattedMessage id='invoiceSteps.button.send'/>
                  {locale === 'ar' ? <ArrowBackIosOutlinedIcon/> : <ArrowForwardIosOutlinedIcon/>}
                </Button>
              </div>
            </Box>
          )}
        </CreateInvoiceConsumer>

      </Grid>
    </Fade>
  )
}

export default InvoiceCreateStep6
